<template>
    <div class="poi-results-item sidebar__section print-break-avoid" :class="{'is-poi-highlight': poi.highlight, 'has-default-hover' : mapConnectionDisabled, 'poi-results-item--print': printStyle}" @mouseenter="elMouseEnterHandler" @mouseleave="elMouseLeaveHandler" @click="resultClickHandler">
        <img :src="poi.image" v-if="poi.image" class="poi-results-item__image"/>
        <div class="poi-results-item__content-wrapper">
            <div class="ui-flex">
                <div class="poi-results-item__content" :class="{'poi-results-item__content--centered': poi.centeredListRow, 'poi-results-item__content--centered': isLoginLocked}">
                    <div class="poi-results-item__row poi-results-item__row--title poi-results-item__title ui-flex ui-center-vertically h3">
                        <Icon class="poi-results-item__title__icon" v-if="isFavourite" :size="16"><IconStar /></Icon>
                        <Icon class="poi-results-item__title__icon poi-results-item__title__icon--up" v-if="isLoginLocked" :size="16"><IconLock /></Icon>
                        {{ poi.title }}
                    </div>
                    <template v-if="!isLoginLocked">
                        <div class="poi-results-item__row poi-results-item__row--infos poi-results-item__infos copy-light" v-if="poi.address || poi.typeName || poi.openingTime || poi.availability || poi.feeAvailability || poi.coordinates || (poi.categoryName && poi.showCategoryNameInList) || poi.updatedAgo">
                            <span class="poi-results-item__info dot-divider dot-divider--info" v-if="poi.categoryName && poi.showCategoryNameInList">{{ poi.categoryName }}</span>
                            <span class="poi-results-item__info dot-divider dot-divider--info" v-if="poi.address">{{ poi.address }}</span>
                            <span class="poi-results-item__info dot-divider dot-divider--info" v-if="poi.typeName">{{ poi.typeName }}</span>
                            <span class="poi-results-item__info ui-nowrap dot-divider dot-divider--info" :class="poi.openingTime.color" v-if="poi.openingTime && !printStyle">{{poi.openingTime.label}}</span>
                            <span class="poi-results-item__info ui-nowrap dot-divider dot-divider--info" :class="poi.availability.color" v-if="poi.availability && !printStyle">{{poi.availability.label}}</span>
                            <span class="poi-results-item__info ui-nowrap dot-divider dot-divider--info" :class="poi.feeAvailability.color" v-if="poi.feeAvailability && !printStyle">{{poi.feeAvailability.label}}</span>
                            <div class="poi-results-item__info" v-if="poi.updatedAgo">aktualisiert vor {{ poi.updatedAgo }}</div>
                            <div class="poi-results-item__info" v-if="poi.coordinates">GPS: {{ poi.coordinates }}</div>
                        </div>
                    </template>
                </div>
                <div v-if="printStyle" class="poi-results-item__additional-info">
                    <div v-if="poi.openingSections && poi.openingSections.sections">
                        <div v-for="(section, index) in poi.openingSections.sections" :key="index" class="poi-results-item__additional-info__block">
                            <div v-if="section.label" class="copy">{{ section.label }}</div>
                            <div v-for="(row, rowIndex) in section.openingHours" :key="rowIndex" class="copy-light">
                                <span>{{row.label}}: </span>
                                <span>
                                    <span>{{ row.hours | formatHours }}</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="poi-results-item__data" :class="{'poi-results-item__data--centered': poi.centeredListRow}">
                    <div class="poi-results-item__row poi-results-item__row--title poi-results-item__data__row ui-nowrap" v-if="!poi.centeredListRow">
                        <span class="h3" v-if="poi.price">{{ poi.price }}</span>
                        <div class="poi-results-item__tag ui-nowrap tag tag--blue" v-if="poi.roadName">{{poi.roadName}}</div>
                        <div class="poi-results-item__tag ui-nowrap tag tag--blue" v-if="poi.country && poi.country.code">{{poi.country.code}}</div>
                    </div>
                    <div class="poi-results-item__row poi-results-item__row--infos poi-results-item__data__row copy-light">
                        <div class="ui-nowrap" v-if="!poi.distance && poi.price && poi.priceUnit">{{poi.priceUnit}}</div>
                        <SmrTooltip content="ÖAMTC Mitgliedervorteil" position="bottom-start" v-if="poi.partnerTag">
                            <div class="poi-results-item__tag ui-nowrap tag tag--yellow">{{poi.partnerTag}}</div>
                        </SmrTooltip>
                        <!-- <div class="poi-results-item__tag ui-nowrap tag tag--yellow" v-if="poi.partnerTag">{{poi.partnerTag}}</div> -->
                        <div class="ui-nowrap" v-if="poi.distance && !printStyle">{{poi.distance | formatDistance }}</div>
                    </div>
                </div>
            </div>

            <div class="poi-results-item__plugs" v-if="poi.plugTypes">
                <div class="poi-results-item__plugs__item ui-spread-center-vertically" v-for="(plug, index) in poi.plugTypes" :key="index">
                    <div class="poi-results-item__plugs__item__left ui-center-vertically">
                        <icon>
                            <PlugIcon :icon="plug.icon" />
                        </icon>
                        {{ plug.name }}
                    </div>
                    <div class="copy-light">
                        <span class="dot-divider dot-divider--info">
                            {{ plug.kW | formatFloatWithComma }} kW
                        </span>
                        <span class="dot-divider dot-divider--info">
                            {{ plug.amount }} x
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import eventBus from '@/utils/event-bus.js';
import { formatDistance, formatFloatWithComma } from '@/utils/format';
import SmrTooltip from '@/components/SmrTooltip.vue'
import { trackEvent, trackGa4Event } from '@/utils/tracking'
import { ONLY_LOGGED_IN_AVAILABLE, isFavourite } from '@/utils/poi-utils';
import Icon from '@/components/Icon.vue'
import IconLock from '@/components/icons/IconLock.vue'
import IconStar from '@/components/icons/IconStar.vue'
import PlugIcon from '@/components/PlugIcon.vue'
import { getFavoritePOITrackingValue } from '@/data/trackingInfo';

export default {
    components: {
        SmrTooltip,
        Icon,
        IconLock,
        IconStar,
        PlugIcon
    },
    props: {
        poi: {
            type: Object,
            default: () => {}
        },
        mapConnectionDisabled: {
            type: Boolean,
            default: false
        },
        detailPageDisabled: {
            type: Boolean,
            default: false
        },
        printStyle: {
            type: Boolean,
            default: false
        },
    },
    data() {
      return {
        trackingPOIs: ['carParks', 'gasStations', 'partners', 'greenzone', 'roadHouses', 'nearbyStations', 'camping', 'passRoads', 'traffic', 'oeamtcLocations', 'tollRoads', 'tunnels', 'sights', 'travelRadar', 'chargingStations'],
      };
    },
    computed: {
        ...mapGetters(['mobile', 'routeTrafficTime', 'user']),
        isLoginLocked() {
            if(this.user) {
                return false
            } else {
                return ONLY_LOGGED_IN_AVAILABLE.includes(this.poi.type)
            }
        },
        isFavourite() {
            if(this.poi.isFavouritePoi) return true
            return isFavourite(this.poi.id)
        }
    },
    mounted() {
    },
    filters: {
        formatDistance(val) {
            return formatDistance(val);
        },
        formatHours(val) {
            const hourString = val.map(v => `${v}`).join(', ')
            return hourString
        },
        formatFloatWithComma(val) {
            return formatFloatWithComma(val)
        }
    },
    methods: {
        elMouseEnterHandler() {
            if(!this.mapConnectionDisabled) eventBus.$emit('toggleHighlightPoi', {id: this.poi.id, highlight: true});
        },
        elMouseLeaveHandler() {
            if(!this.mapConnectionDisabled) eventBus.$emit('toggleHighlightPoi', {id: this.poi.id, highlight: false});
        },
        resultClickHandler() {
            if(this.detailPageDisabled) return
            if(this.isLoginLocked) {
                this.$store.commit('setOpenPOIAfterLogin', {
                    type: this.poi.type,
                    id: this.poi.id,
                    subType: this.poi.subType
                })
                eventBus.$emit('showLoginMenu')
                return
            }
            this.$store.commit('setCustomActivePoiType', this.poi.type);
            this.$store.commit('setActivePoiId', this.poi.id);
            this.$store.commit('setCustomActivePoiSubType', this.poi.subType);
            
            if(this.poi.categoryName === 'Arbeit' || this.poi.categoryName === 'Zuhause' ) {
                const trackingAction = this.poi.categoryName === 'Arbeit' ? 'Work' : 'Home';
                const trackingValue = this.poi.categoryName === 'Arbeit' ? 'work' : 'home';
                trackEvent({ category: 'Favorites', action: trackingAction, label: 'Select' });
                trackGa4Event({ga4Parameter1Name: 'select_poi', ga4Parameter1Value: trackingValue, ga4Event: 'favorites'})
            }

            if( !this.poi.isFavouritePoi && this.trackingPOIs.includes(this.poi.type)) {
                if(this.poi.type === 'traffic' && this.routeTrafficTime.isNow === false) {
                    this.poi.trackingLabel = 'Traffic Forecast';
                    this.poi.ga4Parameter1Value = 'traffic_forecast';
                }
                trackEvent({ category: this.poi.trackingCategory, action: this.poi.trackingAction, label: this.poi.trackingLabel });
                trackGa4Event({ga4Parameter1Name: this.poi.ga4Parameter1Name, ga4Parameter1Value: this.poi.ga4Parameter1Value, ga4Event: this.poi.ga4EventName})
            }

            if(this.poi.isFavouritePoi && this.trackingPOIs.includes(this.poi.type)) {
                trackGa4Event({ga4Parameter1Name: 'select_poi', ga4Parameter1Value: getFavoritePOITrackingValue(this.poi.type), ga4Event: 'favorites'})
            }
        },
    }
}
</script>

<style lang="scss">
.poi-results-item {
    $block: &;
    position: relative;
    display: flex;
    padding-top: 13px;
    padding-bottom: 11px;
    cursor: pointer;

    .no-touch &.has-default-hover:hover,
    &.is-poi-highlight {
        background-color: $color-grey-lightest;
        z-index: 1;
        &::after {
            background-color: transparent;
        }
        #{$block}__title {
            &:after {
                background: linear-gradient(-90deg, rgba($color-grey-lightest, 1), rgba($color-grey-lightest, 0));
            }
        }
    }

    &--print {
        padding-left: 0;
        padding-right: 0;
        cursor: default;
        background: transparent !important;

        &::after {
            background: $color-black-005 !important;
        }

        #{$block} {
            &__image {
                width: 30px;
                height: 30px;
            }
            &__content-wrapper {
                flex-grow: 1;
            }
            
            &__content {
                flex-grow: 0;
                margin-right: 20px;

                @include mq($until: tablet, $media-type: screen) {
                    width: auto;
                    flex-grow: 1;
                }
            }
            &__title {
                white-space: initial;
                height: auto;
                &:after {
                    content: none;
                }
            }
            &__data {
                margin-left: auto;
            }
            &__additional-info {
                @include mq($until: tablet, $media-type: screen) {
                    display: none;
                }
                &__block {
                    &:not(:first-child) {
                        margin-top: 6px;
                    }
                }
            }
            &__plugs {
                width: 40%;
            }
        }
    }

    &::after {
        content: '';
        position: absolute;
        top: 100%;
        right: 0;
        width: calc(100% - 40px - #{$sidebar-horizontal-padding * 2});
        height: 1px;
        background: $color-black-005;
    }

    &__content-wrapper {
        flex-grow: 1;
        overflow: hidden;
    }

    &__content {
        flex-grow: 1;
        overflow: hidden;
        &--centered {
            display: flex;
            align-items: center;
            #{$block}__title {
                overflow: visible;
                white-space: initial;
                height: auto;
                &::after {
                    display: none;
                }
            }
        }
    }

    &__title {
        line-height: 1.1;
        position: relative;
        white-space: nowrap;
        overflow: hidden;
        &::after {
            content: '';
            background: linear-gradient(-90deg, rgba(255,255,255, 1), rgba(255,255,255, 0));
            position: absolute;
            right: 0;
            top: 0;
            height: 100%;
            width: 30px;
        }

        &__icon {
            margin-right: 6px;
            flex-shrink: 0;

            &--up {
                transform: translateY(-2px);
            }
        }
    }

    &__image {
        width: 40px;
        height: 40px;
        margin-right: 16px;
        flex-shrink: 0;
    }

    &__row {
        &--title {
            line-height: 21px;
            height: 21px;
        }
        &--infos {
            line-height: 1.5;
        }
    }

    &__data {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        margin-left: 12px;
        &--centered {
            justify-content: center;
        }
        &__row {
            display: flex;
            flex-direction: column;
            align-items: flex-end;
        }
    }

    &__tag {
        margin-top: 1px;
        margin-bottom: -1px;
    }

    &__infos {
    }

    &__info {
    }

    &__plugs {
        margin-top: 12px;

        &__item {
            &:not(:last-child) {
                margin-bottom: 4px;
            }

            &__left {
                gap: 8px;
            }
        }
    }
}
</style>